import { checkPermissions, useAuth } from "@elit-hair/elit-tools";

import { PERMISSIONS } from "@/constants/permissions";
import { useSettings } from "@/providers/general/settings-provider";

/** The one permission Darwin needs: call-svc's, so call-svc never checks another service's code. */
export const DARWIN_PERMISSION = PERMISSIONS.CALL_DARWIN_MCP_USE;

export function hasDarwinPermission(permissionCodes: string[] | undefined): boolean {
    return checkPermissions(permissionCodes ?? [], [DARWIN_PERMISSION]);
}

/** Darwin shows when the user turned it on in their settings and has the Darwin permission. */
export function useDarwinAccess(): boolean {
    const { currentSettings } = useSettings();
    const { userData } = useAuth();

    return currentSettings.DARWIN_AI_ENABLED && hasDarwinPermission(userData?.permissionCodes);
}
